/**
 * @description global base URLs, starts with API_ prefix
 * @example https://backend.eduschool.uz
 */

/**
 * @description global API endpoints
 */

export const API_UPLOAD_FILE = "/upload-file";
export const API_SIGN_IN = "/employee/login";
export const API_AUTH = "/auth";
export const API_CURRENCY_ALL = "/currency/get-all";
export const API_EXCHANGE_RATES = "/transaction/exchange-rates";
export const API_CASHBOX_TRANSACTION_TOTAL = "/cashbox-transaction/total";
export const API_CASHBOX_TRANSACTION_PAGIN = "/cashbox-transaction/pagin";